import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const CAROUSEL_MESSAGES = [
	'Scanning patient demographics…',
	'Looking for past medical history…',
	'Reviewing prescription records…',
	'Reading progress notes…',
	'Identifying referring practitioners…',
	'Extracting pathology results…',
	'Processing clinical reports…',
	'Verifying Medicare information…',
	'Checking for allergies and warnings…',
	'Mapping investigation results…',
	'Linking practitioner contacts…',
	'Reading the record page by page…',
	'A large record can take several minutes…',
	'Finalising patient record…',
];

const ROTATION_INTERVAL_MS = 2500;

const ImportCarousel: React.FC = () => {
	const [messageIndex, setMessageIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setMessageIndex((prev) => (prev + 1) % CAROUSEL_MESSAGES.length);
		}, ROTATION_INTERVAL_MS);

		return () => clearInterval(interval);
	}, []);

	return (
		<div
			style={{
				textAlign: 'center',
				marginTop: 24,
				minHeight: 40,
				padding: '8px 12px',
				background: 'var(--mg-bg-subtle)',
				border: '1px solid var(--mg-border)',
				borderRadius: 8,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Text
				style={{
					fontSize: 14,
					color: 'var(--mg-text-secondary)',
					transition: 'opacity 0.5s ease-in-out',
					opacity: 1,
				}}
			>
				{CAROUSEL_MESSAGES[messageIndex]}
			</Text>
		</div>
	);
};

export default ImportCarousel;
